(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fx-split-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.fxSplitVideoInit) return;
    window.fxSplitVideoInit = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 749px)');

    function load(video) {
      if (video.dataset.loaded) return;
      var src = mobile.matches ? video.dataset.srcMobile || video.dataset.src : video.dataset.src;
      if (!src) return;
      video.src = src;
      video.dataset.loaded = '1';
    }
    function setState(btn, paused) {
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
    }
    function play(video, btn) {
      load(video);
      var p = video.play();
      if (p && p.catch) p.catch(function () { setState(btn, true); });
      setState(btn, false);
    }

    function init(video) {
      if (video.dataset.fxReady) return;
      video.dataset.fxReady = '1';
      var btn = video.parentElement.querySelector('[data-fx-video-toggle]');
      if (!btn) return;
      btn.hidden = false;
      // Poster stays up if the file fails, so the section never looks broken.
      video.addEventListener('error', function () { btn.hidden = true; }, true);

      if (reduce.matches) {
        video.removeAttribute('autoplay');
        setState(btn, true);
      }
      btn.addEventListener('click', function () {
        if (video.paused) {
          video.dataset.userPaused = '';
          play(video, btn);
        } else {
          video.dataset.userPaused = '1';
          video.pause();
          setState(btn, true);
        }
      });

      if (!('IntersectionObserver' in window)) {
        if (!reduce.matches) play(video, btn);
        return;
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!reduce.matches && !video.dataset.userPaused) play(video, btn);
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { rootMargin: '200px 0px' }).observe(video);
    }

    function scan() {
      document.querySelectorAll('video[data-fx-video]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
